import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';
import type {
  Assignee,
  InstitutionMember,
} from '@backrs_ui/grow-ui/src/redux/coachingDashboard/coachingDashboard.types';
import { personName } from '@backrs_ui/grow-ui/src/utils/personName';

export const useAgentContext = (member: Assignee | InstitutionMember | undefined) => {
  useRegisterAgentContext(
    member
      ? {
          kind: 'entity',
          description: 'The student whose coaching dashboard is currently open.',
          data: {
            user_id: member.id,
            name: personName(member),
          },
        }
      : null,
  );
};
